<template>
    <div>
        <input
            ref="field"
            :accept="accepts"
            type="file"
            name="file"
            class="uploadField"
            multiple
            @change="handleFileUpload()"
        >
        <AppButton
            :loading="loading"
            :small="small"
            label="Upload media"
            @click="$refs.field.click()"
        >
            <template v-slot:icon>
                <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12"/></svg>
            </template>
        </AppButton>
    </div>
</template>

<script>
import axios from 'axios';
import AppButton from '../ui/AppButton.vue';
import handleErrors from '../../utils/errorsHandler';

export default {
    components: {
        AppButton,
    },
    props: {
        typeToPick: {
            type: String,
            default: null,
        },
        small: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        loading: false,
    }),
    computed: {
        accepts() {
            if (this.typeToPick === 'image') {
                return 'image/jpeg, image/png, .svg';
            }

            return null;
        },
    },
    methods: {
        async handleFileUpload() {
            this.loading = true;
            const fileUpload = this.$refs.field.files[0];

            if (!fileUpload) return;

            const files = Array.from(this.$refs.field.files);
            await Promise.all(files.map(async (file) => {
                try {
                    const res = await this.uploadFile(file);
                    this.$emit('newUpload', res.data);
                } catch (error) {
                    handleErrors(error, true);
                }
            }));

            this.loading = false;
            this.$refs.field.value = null;
        },
        async uploadFile(file) {
            const formData = new FormData();
            formData.append('file', file);

            const res = await axios.post('/api/media', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            return res;
        },
    },
};
</script>

<style lang="postcss" scoped>
.uploadField {
    position: absolute;
    top: -500px;
    opacity: 0;
    visibility: hidden;
}
</style>
